import http from '@util/http';
import {incubator} from '@api/req';

export async function queryRefundList(params) {
    return http.get(incubator.REFUND_LIST, params);
  }
export async function queryRefundMy(params) {
    return http.get(incubator.REFUND_MY, params);
  }
export async function queryRefundInfo(params) {
    return http.get(incubator.REFUND_INFO, params);
  }
export async function querySaveRefund(params) {
    return http.post(incubator.REFUND_SAVE, params);
  }
export async function queryNextRefund(params) {
    return http.get(incubator.REFUND_NEXT, params);
  }
export async function queryReturnRefund(params) {
    return http.post(incubator.REFUND_RETURN, params);
  }
export async function queryCallbackRefund(params) {
    return http.get(incubator.REFUND_CALLBACK, params);
  }
export async function queryDeleteRefund(params) {
    return http.get(incubator.REFUND_DELETE, params);
  }
export async function queryRefundWorkflow(params) {
    return http.get(incubator.REFUND_WORKFLOW, params);
  }



// WEBPACK FOOTER //
// ./src/api/incubator/refund.js